/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.function.name.js";
import { camelize, get } from "./utils";
import zh from './zh-CN';
import en from './zh-US';
import Vue from 'vue';
var defineReactive = Vue.util.defineReactive;
defineReactive(Vue.prototype, '$pascLang');
var allLanguage = {
  'zh-CN': zh,
  'en': en
};
export default {
  computed: {
    $t: function $t() {
      var name = this.$options.name;
      var prefix = name ? camelize(name) + "." : "";
      var lang = this.$pascLang || 'zh-CN';
      var messages = allLanguage[lang];
      return function (path) {
        var message = get(messages, prefix + path) || get(messages, path);

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return typeof message === "function" ? message.apply(void 0, args) : message;
      };
    }
  }
};